import Vue from "vue";
import Router from "vue-router";
// import Vant from 'vant';
// import 'vant/lib/vant-css/index.css';
// import 'vant/lib/index.css';

import login from "@/pages/login/login";
// import task from '@/pages/task/message'
import peopleList from "@/pages/people/peopleList";
import set from "@/pages/set/set";
import mainFunc from "@/pages/application/mainFunc";

import rank from "@/pages/application/rank";
import mapData from "@/pages/application/mapData2";
import detailData from "@/pages/application/detailData";
import station_info from "@/pages/application/stationInfo";
import pageIn from "@/pages/application/pageIn";
import mySubscribeSns from "@/pages/application/subscribe/mySubscribeSns";
import subscribe from "@/pages/application/subscribe/subscribe";
import VirtualDevice from "@/pages/application/virtual/VirtualDevice";
// 标准限值页面
import explanation from "@/pages/application/explanation";
import standardLimits from "@/pages/application/standardLimits";
import about from "@/pages/application/about";


import alarmList from "@/pages/application/alarm/alarmList";
import detail from "@/pages/application/alarm/alarmDetail";
import deal from "@/pages/application/alarm/dealAlarm";

// import createTask from '@/pages/task/createTask'
// import taskDetail from '@/pages/task/taskDetail'
// import myTask from '@/pages/task/myTask'
// import taskPublished from '@/pages/task/taskPublished'

import groupDetail from "@/pages/people/groupDetail";
import peopleDetail from "@/pages/people/peopleDetail";


Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}; 
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: "/login", // 登录
      name: "login",
      component: login,
      meta: {
        index: true
      }
    },
    {
      path: "/", // 任务
      name: "index",
      redirect: "/mapData"
    },
    {
      path: "/peopleList", // 通讯录
      name: "peopleList",
      component: peopleList,
      meta: { keepAlive: true, index: true }
    },
    
    {
      path: "/explanation", // 应用
      name: "explanation",
      component: explanation,
      meta: { keepAlive: true, index: true }
    },
    {
      path: "/mainFunc", // 应用
      name: "mainFunc",
      component: mainFunc,
      meta: { keepAlive: true, index: true }
    },
    {
      path: "/set", // 设置
      name: "set",
      component: set,
      meta: { index: false, index: true}
    },
    {
      path: "/rank", // 站点排名
      name: "rank",
      component: rank,
      meta: { keepAlive: true, index: true }
    },

    {
      path: "/mapData", // 地图
      name: "mapData",
      component: mapData,
      meta: { keepAlive: true, index: true }
    },
    {
      path: "/detailData/:id", // 设备详情
      name: "detailData",
      component: detailData,
      meta: { keepAlive: false }
    },
    {
      path: "/station_info/:station_id", //设备信息
      name: "station_info",
      component: station_info
    },
    {
      path: "/alarmList", // 报警列表
      name: "alarmList",
      component: alarmList,
      meta: { keepAlive: true, index: true }
    },
    {
      path: "/alarm/:id", // 报警详情
      name: "detail",
      component: detail
    },
    {
      path: "/deal/:id", // 处理报警
      name: "deal",
      component: deal
    },
    {
      path: "/deal/:id/log/:log_id", // 报警处理日志
      name: "deal_log",
      component: deal
    },

    {
      path: "/pageIn/:site/:name", // iframe嵌入页面  mySubscribeSns
      name: "pageIn",
      component: pageIn
    },
    {
      path: "/mySubscribeSns", // 我订阅的设备
      name: "mySubscribeSns",
      component: mySubscribeSns
    },
    {
      path: "/subscribe/:parent", // 订阅设备
      name: "subscribe",
      component: subscribe
    },
    {
      path: "/subscribe", // 订阅设备
      name: "subscribei",
      component: subscribe
    },
    {
      path: "/userGroup/:group_id", // 分组详情
      name: "userGroup",
      component: groupDetail,
      meta: { keepAlive: true }
    },
    {
      path: "/peopleDetail/:people_id", // 用户详情
      name: "peopleDetail",
      component: peopleDetail,
      meta: { keepAlive: true }
    },
    {
      path: "/VirtualDevice",
      name: "VirtualDevice",
      component: VirtualDevice
    },
    {
      path: "/standardLimits",
      name: "standardLimits",
      component: standardLimits,
    },
    {
      path: "/about",
      name: "about",
      component: about,
    }
    // {
    //   path: '/createTask',                 // 新建任务
    //   name: 'createTask',
    //   component: createTask
    // },
    // {
    //   path: '/createTask/:alarm_id',       // 新建任务关联报警
    //   name: 'createTaskWithAlarm',
    //   component: createTask
    // },
    // {
    //   path: '/taskPublished',              // 我发布的任务
    //   name: 'taskPublished',
    //   component: taskPublished
    // },
    // {
    //   path: '/taskDetail/:task_id',        // 任务详情
    //   name: 'taskDetail',
    //   component: taskDetail
    // },
    // {
    //   path: '/myTask',                     // 我的任务
    //   name: 'myTask',
    //   component: myTask
    // }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js